// extracted by mini-css-extract-plugin
export default {"label":"r1ein","label--disabled":"nfAx2","label__text":"t2ESY"};